import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { ReestrChangeBloc } from '../../_dto/_reestr/ReestrChangeBloc';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiChangeBlocReestr = async (dto: ReestrChangeBloc) => {
  const params: IApiParams = {
    url: '/reestr/changeBloc.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'PUT', dto);
};
